import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators.js';

/**
 * Footer Section Component
 * Footer with branding and legal links
 * Follows constitution.md: Light DOM, Tailwind-first, responsive design
 */
@customElement('footer-section')
export class FooterSection extends LitElement {
  // Disable Shadow DOM to use global Tailwind styles
  protected createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <footer class="bg-surface-base px-4 lg:px-16 py-8">
        <div class="container mx-auto">
          <div
            class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4"
          >
            <!-- Left: Branding -->
            <div class="flex flex-col items-start">
              <a
                href="/"
                class="text-text-primary font-sans font-medium text-sm hover:text-brand-primary transition-colors duration-200"
              >
                Forward Compute
              </a>
            </div>

            <!-- Right: Legal Links and Copyright -->
            <div class="flex flex-col items-start md:items-end gap-2">
              <div class="flex flex-col md:flex-row gap-2 md:gap-4">
                <a
                  href="/policies/privacy-policy"
                  class="text-text-primary text-sm hover:text-brand-primary transition-colors duration-200"
                >
                  Privacy Policy
                </a>
                <a
                  href="/policies/terms-of-service"
                  class="text-text-primary text-sm hover:text-brand-primary transition-colors duration-200"
                >
                  Terms of Service
                </a>
              </div>
              <span class="text-text-secondary text-xs">
                &copy; ${new Date().getFullYear()} Forward Compute
              </span>
            </div>
          </div>
        </div>
      </footer>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'footer-section': FooterSection;
  }
}
